// Phone layout switch: one breakpoint, driven by matchMedia so it follows
// rotation and window resizes.
import { useEffect, useState } from 'react';

export const NARROW_QUERY = '(max-width: 640px)';

function matches(): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia(NARROW_QUERY).matches;
}

export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(matches);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const list = window.matchMedia(NARROW_QUERY);
    const update = () => setNarrow(list.matches);
    update();
    list.addEventListener('change', update);
    return () => list.removeEventListener('change', update);
  }, []);
  return narrow;
}
